import React from "react";
import "./promoanniv.scss";
import Comingsoon from "../../media/Sumser_Hardsell.webp";
import Soon from "../../media/Sumser_Mobile.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6285215127964&text=Halo%20Marketing%20Summarecon,%20Saya%C2%A0bisa%20minta%20detail%20Promo%20terbaru%20Summarecon%20(Promo%20Anniversary)%20https://marketinggadingserpong.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="promoanniversary" className="container-hut">
      <div className="hut">
        <h1>Promo Special Anniversary Summarecon</h1>
      </div>
      <div className="maps-lokasi">
        <img
          id="location"
          className="img-lokasi-dekstop"
          src={Comingsoon}
          alt="maps"
        />
        <img id="lokasi" className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
